import './PayButton.scss'

import { Icon } from '@tallink/components-lib'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { confirmPayment } from '../../../../actions/actions'
import {
  getPayment,
  getUser,
  isDeliveryDetailsValid,
  isFreeReservation,
  isInvoicePaymentMethod
} from '../../../../selectors/selectors'
import Button from '../../../common/Button'

export default function PayButton() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const payment = useSelector(getPayment)
  const user = useSelector(getUser)
  const deliveryDetailsValid = useSelector(isDeliveryDetailsValid)
  const invoicePaymentMethod = useSelector(isInvoicePaymentMethod)
  const freeReservation = useSelector(isFreeReservation)
  const payButtonAvailable = (user.clientId || deliveryDetailsValid) && !payment.paymentConfirmed
  const [errorMessages, setErrorMessages] = useState([])

  const handleConfirmClick = async () => {
    setErrorMessages([])
    const confirmResponse = await dispatch(confirmPayment())
    if (confirmResponse?.error) setErrorMessages(confirmResponse.messages)
  }

  const getButtonText = () => {
    if (freeReservation) return t('paymentPage.confirm.freeReservation')
    if (invoicePaymentMethod) return t('paymentPage.confirm.onlyPayment.withInvoice')
    return t('paymentPage.confirm.onlyPayment')
  }

  return (
    <div className="pay-button">
      <Button
        className="button-primary-lg confirm-payment-button"
        disabled={!payButtonAvailable}
        onClick={handleConfirmClick}
        processing={payment.paymentConfirmed}
      >
        {getButtonText()}
      </Button>
      {errorMessages.map(message => (
        <div className="error" key={message}>
          <Icon type="exclamation-triangle-fill" />
          <span className="message">{message}</span>
        </div>
      ))}
    </div>
  )
}
